module.exports = __webpack_public_path__ + "img/slide-img-01.4def44ec.png";